/**
 * Controller: programsInstanceEditCancelModal
 */
angular.module('acme.view.application.programs.instance.edit.cancelModal.controllers', [])
.controller('ProgramsInstanceEditCancelModalController', [ '$scope', '$uibModalInstance', 'currentEvent', 'emailSetting', function($scope, $uibModalInstance, currentEvent, emailSetting) {

  $scope.instanceEditCancelModal = {
    
    model: {},

    notificationEmail: true,
    notificationType: 'always',
    notificationList: [],

    init: function() {
      this.model = currentEvent;
      this.setNotificationList();

      this.notificationType = emailSetting;
    },

    setNotificationList: function() {
      var self = $scope.instanceEditCancelModal;
      if (this.model.hasOwnProperty('resources')) {
        angular.forEach(this.model.resources, function(item, index) {
          if (item.resourceCategory === 'Personnel' &&
              item.resourceName &&
              item.resourceName.length) {
            self.notificationList.push(item.resourceName);
          }
        });
      } else if (this.model.hasOwnProperty('requestSummary')){
        self.notificationList = this.model.requestSummary.people.resourceNames;
      }
    },

    checkNotification: function() {
      if (this.notificationType === 'never') {
        this.notificationEmail = false;
      }

      this.model.sendEmailToResources = this.notificationEmail;
    },

    close: function() {
      $uibModalInstance.dismiss('cancel');
    },

    done: function() {
      this.checkNotification();
      $uibModalInstance.close($scope.instanceEditCancelModal.model);
    }

  };

  $scope.instanceEditCancelModal.init();

}]);

